import { StyleSheet } from 'react-native';

import { Skeleton, tokens } from '@fhs/ui';

export function ChallengeHomeCardSkeleton() {
  return <Skeleton style={styles.image} />;
}

const styles = StyleSheet.create({
  image: {
    width: '100%',
    height: 127,
    borderRadius: 8,
    backgroundColor: tokens.colors.$blackOpacity10,
  },
});
